import * as Net from 'util/Net';

/**
 * Shape of the `configuration` JSON bag exposed by `AgentFactoryNode.configuration`. `description`
 * is not a first-class field on the domain type, so it's read out of this opaque bag instead. See
 * `AgentFactoryTable.configuration` on the backend.
 */
export interface AgentFactoryConfiguration {
  description?: string;
}

export function getAgentFactoryDescription(configuration: JSONScalar): string {
  return (configuration as AgentFactoryConfiguration).description ?? '';
}

export function createAgentFactory(name: string, description: string): Promise<{agentFactoryId: string}> {
  return Net.postJSONPromise({url: '/1/api/llm/agent-factories', data: {name, description}});
}
